import {
  ref,
  inject,
  computed,
  watch,
} from '@vue/composition-api';
import { useCoverBoostTrackers } from '@/composables/coverBoostTrackers';

export default (result, context) => {
  // prerequisites
  const config = inject('config');
  const constants = inject('constants');
  const { setMoreInfoClick } = useCoverBoostTrackers(context);
  const {
    allResults,
    detailsQuote,
    quotePositionNumber,
    openDetailsDrawer,
    drawerComponent,
    isDetailsDrawerOpen,
  } = result;
  const coverBoostProducts = ref([]);
  const selectedPremium = ref(null);
  const screenWidth = computed(() => context.root.$vuetify.breakpoint.width);
  const isDesktop = computed(() => screenWidth >= 768);
  const coverBoostEnabled = config.coverBoostDesktopResults > 0 && config.coverBoostMobileResults > 0 && config.coverBoostEnabled;

  /**
   * Clear the product which user selects on coverBoost sidebar if drawer closed
   */
  watch(isDetailsDrawerOpen, (val) => {
    if (val === false) selectedPremium.value = null;
  });

  /**
   * Find related products to current selected coverBoost product
   * @param quoteDetail
   * @returns {*[]}
   */
  const getCoverBoostProducts = (quoteDetail) => {
    if (!quoteDetail) return;
    // Apparently there are limits how many coverBoost products (columns) should be shown in the drawer
    const { coverBoostDesktopResults, coverBoostMobileResults } = config;
    const products = [quoteDetail];

    let addMoreProductsDesktop = false;
    let addMoreProductsMobile = false;

    if (quoteDetail.coverBoost && config.coverBoostEnabled) {
      quoteDetail.coverBoost.forEach((cb) => {
        const coverBoostProduct = allResults.value.find(r => r.details[0].premiumID === cb);

        addMoreProductsDesktop = (products.length < coverBoostDesktopResults) && isDesktop;
        addMoreProductsMobile = (products.length < coverBoostMobileResults) && !isDesktop;

        if ((addMoreProductsMobile || addMoreProductsDesktop) && coverBoostProduct) {
          products.push(coverBoostProduct.details[0]);
        }
      });

      return products.sort((a, b) => a.calcAnnual > b.calcAnnual);
    }

    return products;
  };

  /**
   * Check if product is coverBoost related and open coverBoostOptions drawer
   * @param $event
   * @param index
   */
  const handleClickViewDetailsResultQuote = ($event, index) => {
    detailsQuote.value = $event;
    quotePositionNumber.value = index + 1;

    const quoteDetail = detailsQuote.value.details[0];
    // Only open the cover boost drawer if they are to be displayed
    drawerComponent.value = coverBoostEnabled && quoteDetail.coverBoost?.length
      ? constants.DRAWER_COMPONENTS.coverBoostOptions
      : constants.DRAWER_COMPONENTS.resultsDetails;

    coverBoostProducts.value = getCoverBoostProducts(quoteDetail);
    openDetailsDrawer([drawerComponent.value, 'optionalExtras']);
    setMoreInfoClick(coverBoostProducts.value);
  };

  /**
   *  Find and save the product, which was selected in coverBoost sidebar
   * @param $event
   */
  const handleClickViewDetails = ($event) => {
    selectedPremium.value = allResults.value.filter(r => r.details[0].premiumID === $event)[0];
  };

  return {
    coverBoostProducts,
    coverBoostEnabled,
    selectedPremium,
    handleClickViewDetailsResultQuote,
    getCoverBoostProducts,
    handleClickViewDetails,
  };
};
